import { StateType } from 'src/types/redux/user.redux.types';
import { UserNamesTableResultType, UsersTableResultType } from 'src/types/services/user-service.type';
import { EventResultType } from 'src/types/services/events-service.type';

export type AssignedTo = string | null | undefined;

const ADMIN_ROLE_ABBREVIATION = 'Admin';
const ROOT_USERNAME = 'root';

type UserWithEventsRoles = Pick<UsersTableResultType, 'events'> | Pick<StateType, 'events'>;

export const isAdminForEvent = (user: UserWithEventsRoles, eventId: string): boolean => {
  return user.events.some(
    (event) => event.id === eventId && event.roles.some((role) => role.abbreviation === ADMIN_ROLE_ABBREVIATION),
  );
};

export const shouldShowOnlyAdminUsers = (taskedToId: AssignedTo, userState: StateType, eventId: string): boolean => {
  const isCurrentUserAdmin = isAdminForEvent(userState, eventId);
  const isTaskAssignedToCurrentUser = userState.id === taskedToId;

  return !isCurrentUserAdmin && !isTaskAssignedToCurrentUser;
};

export const getAdminUsersOfEvent = (usersList: UsersTableResultType[], eventId: string): UsersTableResultType[] => {
  return usersList
    .filter((user) => isAdminForEvent(user, eventId))
    .filter((user) => user.userName.toLowerCase() !== ROOT_USERNAME);
};

export const sortUsersByUserName = <T extends UserNamesTableResultType | UsersTableResultType>(users: T[]): T[] => {
  return [...users].sort((a, b) => a.userName.localeCompare(b.userName));
};

export const findDefaultRlsmAdminUser = (
  eventList: EventResultType[],
  eventId: string,
  userList: UsersTableResultType[],
) => {
  const currentEvent = eventList.find((e) => e.id === eventId);

  if (!currentEvent?.defaultRlsmAdminUserId) return;

  return userList.find((u) => u.id === currentEvent.defaultRlsmAdminUserId);
};

export const getOneAdminUser = (
  userList: UsersTableResultType[],
  eventId: string,
): UsersTableResultType | undefined => {
  return userList.find((user) => isAdminForEvent(user, eventId));
};

export const findAdminUser = (userList: UsersTableResultType[], eventId: string, eventList: EventResultType[]) => {
  return findDefaultRlsmAdminUser(eventList, eventId, userList) || getOneAdminUser(userList, eventId);
};

export const isAssignedToDisabled = (
  setEditModal: boolean,
  setViewModal: boolean,
  taskedToId: AssignedTo,
  userState: StateType,
  eventId: string,
) => {
  return (setEditModal && shouldShowOnlyAdminUsers(taskedToId, userState, eventId)) || setViewModal;
};
